import React from 'react';
import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { replace } from 'connected-react-router';

import AuthLoader from './auth/AuthLoader';

export const withAdminAuthenticated = connectedReduxRedirect({
  wrapperDisplayName: 'AdminIsAuthenticated',
  redirectPath: '/login',
  authenticatedSelector: ({ auth }) => !!auth,
  authenticatingSelector: ({ auth }) => auth === false,
  AuthenticatingComponent: () => <AuthLoader />,
  redirectAction: replace,
});

const locationHelper = locationHelperBuilder({});

export const withAdminNotAuthenticated = connectedReduxRedirect({
  wrapperDisplayName: 'AdminIsNotAuthenticated',
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/',
  allowRedirectBack: false,
  authenticatedSelector: ({ auth }) => auth === null,
  authenticatingSelector: ({ auth }) => auth === false,
  AuthenticatingComponent: () => <AuthLoader />,
  redirectAction: replace,
});
